import actionCreator from '../../createAction';

const createAction = actionCreator('notes');

export const GET_NOTE = createAction('GET_NOTE');
